import gql from 'graphql-tag';

export const SitePersonalizationQuery =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		query SitePersonalizationQuery($cloudId: String!) @experimental {
			experimentalSitePersonalization(cloudId: $cloudId) {
				attributes {
					name
					value
				}
			}
		}
	`;
